const ALLOWED_PROTOCOLS = new Set(["http:", "https:"]);

/**
 * Returns a normalized href for an ops-entered link, or `undefined` when the
 * link is missing, unparseable, or not `http:`/`https:` (e.g. `javascript:`).
 */
export function getSafeExternalUrl(link?: string | null): string | undefined {
  if (!link) {
    return undefined;
  }
  try {
    const url = new URL(link.trim());
    return ALLOWED_PROTOCOLS.has(url.protocol) ? url.href : undefined;
  } catch {
    return undefined;
  }
}
